import * as React from "react";
import { Avatar } from "antd";

import EthIcon from "./icons/ethereum-(eth).svg";
import BtcIcon from "./icons/bitcoin-(btc).svg";
import BftIcon from "./icons/bft.svg";
import TetherIcon from "./icons/tether.svg";

import * as styles from "./CurrencyAvatarStyles.module.scss";

const currenciesToIcon: any = {
  eth: <EthIcon />,
  btc: <BtcIcon />,
  bfusd: <TetherIcon />,
  bft: <BftIcon />,
  staked_eth: <EthIcon />,
};

type Props = {
  currency: string;
  background: string;
};

const CurrencyAvatar = ({ currency, background }: Props) => {
  return (
    <div className={styles.avatar}>
      <Avatar
        icon={currenciesToIcon[currency] ?? undefined}
        style={{ backgroundColor: background }}
      >
        {!currenciesToIcon[currency] ? currency.toUpperCase() : ""}
      </Avatar>
    </div>
  );
};

export default CurrencyAvatar;
